import { createPlugin, createRoutableExtension } from '@backstage/core-plugin-api';

import { rootRouteRef } from './routes';

export const routingPlugin = createPlugin({
  id: 'routing',
  routes: {
    root: rootRouteRef,
  },
});

export const RoutingPage = routingPlugin.provide(
  createRoutableExtension({
    name: 'RoutingPage',
    component: () =>
      import('./components/RoutingComponent').then(m => m.RoutingComponent),
    mountPoint: rootRouteRef,
  }),
);
